/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropzone-demo.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../shared/panel/panel.component.ngfactory';
import * as i3 from '../../../../../src/app/shared/panel/panel.component';
import * as i4 from '../../shared/dropzone/dropzone.component.ngfactory';
import * as i5 from '../../../../../src/app/shared/dropzone/dropzone.component';
import * as i6 from '../../shared/grid/grid.component.ngfactory';
import * as i7 from '../../../../../src/app/shared/grid/grid.component';
import * as i8 from '../../../../../src/app/file-utilities/dropzone/dropzone-demo.component';
const styles_DropzoneDemoComponent:any[] = [i0.styles];
export const RenderType_DropzoneDemoComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_DropzoneDemoComponent,data:{}});
function View_DropzoneDemoComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'admin-panel',
      [['headerColor','rgb(240,159,166)']],[[2,'tabbed',(null as any)],[2,'minimized',
          (null as any)],[2,'closed',(null as any)]],(null as any),(null as any),i2.View_PanelComponent_0,
      i2.RenderType_PanelComponent)),i1.ɵdid(4767744,(null as any),0,i3.PanelComponent,
      ([] as any[]),{showHeader:[0,'showHeader'],headerColor:[1,'headerColor']},(null as any)),
      (_l()(),i1.ɵeld(0,(null as any),0,2,'header',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Dropzone'])),
      (_l()(),i1.ɵeld(0,(null as any),1,1,'admin-dropzone',([] as any[]),(null as any),
          (null as any),(null as any),i4.View_DropzoneComponent_0,i4.RenderType_DropzoneComponent)),
      i1.ɵdid(4374528,(null as any),0,i5.DropzoneComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    const currVal_3:any = true;
    const currVal_4:any = 'rgb(240,159,166)';
    _ck(_v,1,0,currVal_3,currVal_4);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).tabbed;
    const currVal_1:any = i1.ɵnov(_v,1).isMinimized;
    const currVal_2:any = i1.ɵnov(_v,1).isClosed;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
export function View_DropzoneDemoComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),i6.View_GridComponent_0,i6.RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i7.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,1,{templates:1}),(_l()(),i1.ɵand(0,[[1,2]],(null as any),0,
          (null as any),View_DropzoneDemoComponent_1))],(null as any),(null as any));
}
export function View_DropzoneDemoComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_DropzoneDemoComponent_0,
      RenderType_DropzoneDemoComponent)),i1.ɵdid(49152,(null as any),0,i8.DropzoneDemoComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const DropzoneDemoComponentNgFactory:i1.ComponentFactory<i8.DropzoneDemoComponent> = i1.ɵccf('ng-component',
    i8.DropzoneDemoComponent,View_DropzoneDemoComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZmlsZS11dGlsaXRpZXMvZHJvcHpvbmUvZHJvcHpvbmUtZGVtby5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9maWxlLXV0aWxpdGllcy9kcm9wem9uZS9kcm9wem9uZS1kZW1vLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZmlsZS11dGlsaXRpZXMvZHJvcHpvbmUvZHJvcHpvbmUtZGVtby5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvZmlsZS11dGlsaXRpZXMvZHJvcHpvbmUvZHJvcHpvbmUtZGVtby5jb21wb25lbnQudHMuRHJvcHpvbmVEZW1vQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFkbWluLWdyaWQ+PG5nLXRlbXBsYXRlPjxhZG1pbi1wYW5lbCBbc2hvd0hlYWRlcl09XCJ0cnVlXCIgaGVhZGVyQ29sb3I9XCJyZ2IoMjQwLDE1OSwxNjYpXCI+PGhlYWRlcj48aDM+RHJvcHpvbmU8L2gzPjwvaGVhZGVyPjxhZG1pbi1kcm9wem9uZT48L2FkbWluLWRyb3B6b25lPjwvYWRtaW4tcGFuZWw+PC9uZy10ZW1wbGF0ZT48L2FkbWluLWdyaWQ+IiwiPG5nLWNvbXBvbmVudD48L25nLWNvbXBvbmVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXlCO01BQUE7VUFBQTtrQ0FBQSxVQUFBO01BQUE7TUFBZ0U7VUFBQSw0Q0FBUTtVQUFBO1VBQUEsOEJBQUk7TUFBc0I7VUFBQTthQUFBO1VBQUE7SUFBckY7SUFBb0I7SUFBakMsV0FBYSxVQUFvQixTQUFqQzs7SUFBQTtJQUFBO0lBQUE7SUFBQSxXQUFBLDZCQUFBOzs7O29CQUF6QjtNQUFBO2FBQUE7YUFBQSw0QkFBWTtVQUFBOzs7b0JDQVo7TUFBQTtzQ0FBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/file-utilities/dropzone/dropzone-demo.component.ngfactory.ts